<div class="content">
	<!-- TODO filters go here	-->

	<table mat-table [dataSource]="dataSource">
		<ng-container matColumnDef="appointmentTime">
			<td mat-cell *matCellDef="let row">
				<div>{{ row.appointmentTime | orgDate : 'shortTime' }}</div>
				<div class="sub">{{ row.appointmentTime | orgDate : 'shortDate' }}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="patientName">
			<td mat-cell *matCellDef="let row">
				<div class="name">{{ row.patientName }}</div>
				<div class="sub">{{ row.patient.mrn }} | {{ row.patient | ageSex }}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<td mat-cell *matCellDef="let row">
				{{ row.status }}
			</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<td mat-cell *matCellDef="let row">
				<mat-icon>chevron_right</mat-icon>
			</td>
		</ng-container>

		<tr mat-row *matRowDef="let row; columns: displayedColumns;"
		    routerLinkActive="selected"
		    routerLink="/appointments/{{row.appointmentId}}"></tr>
	</table>
</div>
